import React from "react";
import Button from "react-bootstrap/Button";
import { FaArrowLeft } from "react-icons/fa";

const PageHeader = ({ title, backTo }) => {
  return (
    <div className="page-head container">
      <div className="modal-header border-bottom-0 p-2 ps-3 text-center align-items-center justify-content-center position-relative">
        {backTo ? (
          <div className="position-absolute start-0">
            <Button
              type="button"
              variant="transparent"
              className="btn btn-outline-light border-0"
              aria-label="Close"
              onClick={backTo}
            >
              <FaArrowLeft color="#202020" />
            </Button>
          </div>
        ) : null}
        <div className="modal-title  text-capitalize" style={{ fontSize: 14 }}>
          {title}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
